import React, { useState, useEffect, useContext } from "react";
import cn from "classnames";
import styles from "./OrderDetailsView.module.sass";
import Card from "../../../components/Card";
import TextInput from "../../../components/TextInput";
import LoadingIndicator from "../../../LoadingScreen/LoadingIndicator";
import { GlobalState } from "../../../App";
import { ORDER_STATUS, ORDER_STATUS_1 } from "../../../utils/constants";
import { toIsoString } from "../../../utils/extensions";


const OrderDetailsView = ({ orderDetails }) => {
  const { orderStatus2, setOrderStatus2, CURRENCY } = useContext(GlobalState)

  useEffect(() => {
    setTimeout(() => {
      const statusDiv = document.getElementById(ORDER_STATUS).innerText;
      setOrderStatus2(statusDiv)
    }, 1000);
  }, [orderStatus2]);

  const [loading, setLoading] = useState(true)
  const [updatedOrderDetails, setUpdatedOrderDetails] = useState([])

  useEffect(() => {
    if (orderDetails) {
      orderDetails.forEach((element, i) => {
        setUpdatedOrderDetails((oldData) => [...oldData, element])

      });

      setLoading(false)
    }
  }, [orderDetails])

  useEffect(() => {

  }, [updatedOrderDetails]);

  return (

    <Card
      className={cn(styles.card)}
    >
      {
        loading ? <LoadingIndicator /> :

          updatedOrderDetails?.map((x, index) => {
            return (
              <div key={index} className={styles.description}>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Customer name"
                    name="customerName"
                    type="text"
                    value={x?.data?.customerName}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Contact number"
                    name="contactNum"
                    type="text"
                    value={x?.data?.contactNumber}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Customer address"
                    name="customerAddrs"
                    type="text"
                    value={x?.data?.customerAddress}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Sub total"
                    name="subTotal"
                    currency={CURRENCY}
                    // type="number"
                    value={(x?.data?.subtotal !== '' && x?.data?.subtotal !== undefined) ? x?.data?.subtotal : "-"}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Shipping"
                    currency={CURRENCY}
                    name="shipping"
                    // type="number"
                    value={(x?.data?.shippingCost !== '' && x?.data?.shippingCost !== undefined) ? x?.data?.shippingCost : "-"}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="VAT"
                    name="vat"
                    currency={CURRENCY}
                    // type="number"
                    value={(x?.data?.vatAmount !== '' && x?.data?.vatAmount !== undefined) ? x?.data?.vatAmount : "-"}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Total"
                    name="total"
                    currency={CURRENCY}
                    value={x?.data?.total}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Status"
                    name="status"
                    type="text"
                    value={
                      orderStatus2?.charAt(0).toUpperCase() + orderStatus2?.slice(1).toLowerCase()
                    }
                    id={ORDER_STATUS_1}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Date created"
                    name="dateCreated"
                    type="text"
                    value={
                      // split("T")[0].replaceAll("-", "/").split('/').reverse().join('/')
                      // toIsoString(new Date(
                      //   x?.data?.dateCreated?.seconds * 1000 + x?.data?.dateCreated?.nanoseconds / 1000000,
                      // ))
                      x?.data?.dateCreated?.seconds === undefined ?
                        x?.data?.dateCreated?.split("T")[0].replaceAll("-", "/").split('/').reverse().join('/') :
                        toIsoString(new Date(
                          x?.data?.dateCreated?.seconds * 1000 + x?.data?.dateCreated?.nanoseconds / 1000000,
                        )).split("T")[0].replaceAll("-", "/").split('/').reverse().join('/')

                    }
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Sales channel"
                    name="salesChnl"
                    type="text"
                    value={x?.data?.salesChannel}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Payment Method"
                    name="payMethod"
                    type="text"
                    value={x?.data?.paymentMethod}
                    readOnly={true}
                  />
                </div>

                <div className={styles.fieldContainer}>
                  <TextInput
                    className={styles.field}
                    classInput={styles.fieldInput}
                    label="Transaction ID"
                    name="titleEn"
                    type="text"
                    value={(x?.data?.transactionId !== '' && x?.data?.transactionId !== undefined) ? x?.data?.transactionId : "-"}
                    readOnly={true}
                  />
                </div>

              </div>
            )
          })
      }

    </Card >
  );
};

export default OrderDetailsView;
